import type { AppRecordDoneWork, ThreadTopicSummary } from '@shared/types/thread-work';
import { supabase } from './supabase';
import { toDashboardUiError } from './dashboard-errors';

/** N1/N2: the next actions of one object of an app, for the person who reads it. */
export interface AppRecordActionsView {
  threadId: string | null;
  /** The plan in place read this very object, objectives and guidance. */
  current: boolean;
  preparing: boolean;
  failed: boolean;
  actions: ThreadTopicSummary[];
  /** What was done on the object, newest first, kept where it was done. */
  done: AppRecordDoneWork[];
}

export interface AppNextActionsView {
  threadId: string | null;
  byRecord: Record<string, { title: string; count: number }>;
}

/** Asks the object's next actions (« Proposer la suite », « Actualiser »); reused while nothing they read changed. */
export const planAppRecord = async (recordId: string): Promise<void> => {
  const { error } = await supabase.functions.invoke('activity-feed', { body: { action: 'plan_app_record', recordId } });
  if (error) throw new Error((await toDashboardUiError(error, 'Les prochaines actions n’ont pas pu être demandées.')).message);
};

export const readAppRecordActions = async (recordId: string): Promise<AppRecordActionsView | null> => {
  const { data, error } = await supabase.functions.invoke('activity-feed', { body: { action: 'app_record_actions', recordId } });
  if (error) throw new Error((await toDashboardUiError(error, 'Les prochaines actions n’ont pas pu être chargées.')).message);
  return (data as { view?: AppRecordActionsView | null } | null)?.view ?? null;
};

/** The first next action of each object, for the app's list. */
export const readAppNextActions = async (flowId: string): Promise<AppNextActionsView | null> => {
  const { data, error } = await supabase.functions.invoke('activity-feed', { body: { action: 'app_next_actions', flowId } });
  if (error) throw new Error((await toDashboardUiError(error, 'Les prochaines actions n’ont pas pu être chargées.')).message);
  return (data as { view?: AppNextActionsView | null } | null)?.view ?? null;
};
